import * as PIXI from 'pixi.js';

export default class Confetti {
    constructor() {
        this.SP = 768;
        this.PC = 1920;
        this.init();
    }

    init() {
        this.cw = window.innerWidth;
        this.ch = window.innerHeight;
        this.createNum = this.getCreateNum();
        this.color = [0xffffff, 0xff686e, 0x65c3ea];
        this.xAdd = [];
        this.sprites = [];
        this.scale = [];
        this.killed = false;

        this.createPixi();
        this.render();
    }

    getCreateNum() {
        let num = 0;

        if (window.innerWidth < this.SP) {
            // num = 5;
            num = 3;
        } else {
            // num = 10 * (window.innerWidth / this.PC);
            num = 8 * (window.innerWidth / this.PC);
        }

        return num;
    }

    getRandSprite(randType) {
        const textures = [
            PIXI.Texture.from('./assets/img/ico_kani.png'),
            PIXI.Texture.from('./assets/img/ico_kani.png'),
            this.createAnimatedSprite()
        ];

        return randType === 2 ? textures[2] : new PIXI.Sprite(textures[randType]);
    }

    createAnimatedSprite() {
        const frames = [
            PIXI.Texture.from('./assets/img/ico_kani.png'),
            PIXI.Texture.from('./assets/img/ico_kani_bigeyes.png')
        ];

        const animatedSprite = new PIXI.AnimatedSprite(frames);
        animatedSprite.animationSpeed = 0.05; // アニメーションのスピードを調整
        animatedSprite.play();
        return animatedSprite;
    }

    createPixi() {
        this.app = new PIXI.Application({ width: this.cw, height: this.ch, backgroundAlpha: 0, resolution: Math.min(2, window.devicePixelRatio || 1), autoResize: true });
        this.app.view.classList.add('l-canvas');
        document.body.appendChild(this.app.view);

        for (let i = 0; i < this.createNum; i++) {
            const x = Math.floor(Math.random() * this.cw) + 10;
            const y = Math.floor(Math.random() * this.ch);
            const randType = Math.floor(Math.random() * 3);

            this.scale.push(window.innerWidth < this.SP ? Math.random() * 0.2 + 0.2 : Math.random() * 0.3 + 0.2);
            this.xAdd.push(i % 2 === 0 ? 1 : -1);

            const sprite = this.getRandSprite(randType);
            this.sprites.push(sprite);
            this.sprites[i].position.x = x;
            this.sprites[i].position.y = y;
            this.sprites[i].scale.set(this.scale[i]);
            this.sprites[i].rotation = 0.1 + (i % 5) * 0.1;
            this.app.stage.addChild(this.sprites[i]);
        }

        window.addEventListener('resize', this.onResize.bind(this));
    }

    onResize() {
        this.cw = window.innerWidth;
        this.ch = window.innerHeight;
        this.app.renderer.resize(this.cw, this.ch);
    }

    render() {
        this.app.ticker.add((delta) => this.update(delta));
    }

    killRender() {
        if (this.killed) {
            return;
        }
        this.killed = true;
        this.app.view.classList.add('-disable');
        setTimeout(() => {
            this.app.ticker.stop();
        }, 1000);
    }

    update(delta) {
        const xPlus = [0.5, 0.75, 1, 1.2, 1.5];

        for (let i = 0; i < this.createNum; i++) {
            if (!this.sprites[i]) continue;

            let x;
            let y;

            if (this.sprites[i].y > this.ch) {
                x = Math.floor(Math.random() * this.cw) + 10;
                y = -10;
            } else {
                y = this.sprites[i].y + 2 + (i % 5) * 0.1;
            }

            if (this.sprites[i].x > this.cw - 10) {
                this.xAdd[i] = -1;
            } else if (this.sprites[i].x < 10) {
                this.xAdd[i] = 1;
            }

            if (this.xAdd[i] === -1) {
                x = this.sprites[i].x - xPlus[i % 5];
            } else {
                x = this.sprites[i].x + xPlus[i % 5];
            }

            this.sprites[i].position.x = x;
            this.sprites[i].position.y = y;
            this.sprites[i].rotation += i % 2 === 0 ? 0.01 + (i % 5) * 0.01 : 0.01 + (i % 5) * -0.01;
        }
    }
}
